<template>
  <div>
    <h3>用户列表</h3>
    <el-table :data="tableData" border style="width: 100%;margin-top:20px">
      <el-table-column prop="id" label="ID" width="80"></el-table-column>
      <el-table-column prop="title" label="标题"></el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: []
    }
  },
  async mounted() {
    // Axios 远程拿数据
    await this.getUserList()
  },
  methods: {
    async getUserList() {
      try {
        const res = await this.$axios.get('https://jsonplaceholder.typicode.com/posts')
        this.tableData = res.data.slice(0,15)
      } catch (err) {
        this.$message.error('数据加载失败')
      }
    }
  }
}
</script>